import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { Field, getFormValues } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';
import Card from '@material-ui/core/Card';
import { CardHeader, Switch } from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import styles from './styles';
import formFields from './formFields';
import GeneralCheckbox from '../../../../fields/normal/GeneralCheckbox';
import { FORMS } from '../../../../constants';
import {
  auMobileNumber,
  auPhoneNumber,
} from '../../../../utilities/validators';

const propTypes = {
  classes: PropTypes.shape({
    formGroup: PropTypes.string,
    hidden: PropTypes.string,
  }).isRequired,
  isBuilder: PropTypes.bool.isRequired,
  formValues: PropTypes.object,
  changeFieldValue: PropTypes.func.isRequired,
};

export const FieldsGroupOne = props => {
  const [phoneIsDuplicate, setPhoneIsDuplicate] = useState(false);
  const [expiryDate, setExpiryDate] = useState('');
  const [showInSearch, setShowInSearch] = useState(true);

  const { classes, isBuilder, formValues, changeFieldValue } = props;
  useEffect(() => {
    if (formValues) {
      formValues.showInSearch = showInSearch;
    }
  }, [showInSearch, formValues]);

  const registrationFormFields = isBuilder
    ? formFields
    : formFields
        .filter(
          field =>
            field.name !== 'custom:buildingLicNo' &&
            field.name !== 'custom:buildingLicExp' &&
            field.name !== 'custom:buildingLicExpMask',
        )
        .map(fields => {
          if (fields.name === 'custom:personalPhone') {
            return {
              ...fields,
              props: {
                ...fields.props,
                label: 'Primary Contact Number (optional)',
                required: false,
              },
              validate: [auPhoneNumber],
            };
          }
          return fields;
        });

  const primaryNumberIsMobile =
    formValues &&
    formValues['custom:personalPhone'] &&
    !auMobileNumber(formValues['custom:personalPhone']);

  const duplicatePhoneFields = isSame => {
    if (isSame) {
      changeFieldValue(
        'custom:mobileNumber',
        formValues['custom:personalPhone'],
      );
    } else {
      changeFieldValue('custom:mobileNumber', '');
    }
    setPhoneIsDuplicate(isSame);
  };

  // Wait for formValues load and set initial date
  useEffect(() => {
    if (!expiryDate && formValues) {
      setExpiryDate(formValues['custom:buildingLicExp']);
    }
  });

  // Render datepicker and hide 'trueInput' field
  useEffect(() => {
    if (expiryDate) {
      const maskInput = document.querySelector(
        '#building-licence-expiry-mask-field',
      );
      const trueInput = document.querySelector(
        '#building-licence-expiry-text-field',
      );
      if (maskInput) {
        formValues['custom:buildingLicExp'] = expiryDate;
        hideTrueInput(trueInput);
        renderFlatpickr(maskInput);
        const formatDate = moment(expiryDate).format('DD-MM-YYYY');
        if (maskInput.value !== formatDate) {
          maskInput.value = formatDate;
        }
      }
    }
  }, [expiryDate]);

  // console.log({ formValues });

  // Hide true input field
  const hideTrueInput = el => {
    el.classList.add('hidden-date');
    for (let i = 0; i < 5; i += 1) {
      // eslint-disable-next-line no-unused-expressions
      el.nextSibling === null
        ? (el = el.parentElement)
        : (el.style.display = 'none');
    }
  };

  // Render datepicker element
  const renderFlatpickr = async maskInput => {
    const options = {
      dateFormat: 'd-m-Y',
      minDate: 'today',
      disableMobile: true,
      onChange: () => {
        const [selectedDate] = datepicker.selectedDates;
        setExpiryDate(selectedDate.toISOString());
      },
    };
    const datepicker = await flatpickr(maskInput, options);
    datepicker.calendarContainer.style.fontFamily = '"Helvetica Neue", Arial';
  };

  // console.log({ registrationFormFields });

  return (
    <Card>
      <CardHeader
        classes={{
          root: classes.cardHeaderRoot,
          title: classes.cardHeaderTitle,
        }}
        title="Step1: Your Details"
      />
      <CardContent>
        {registrationFormFields.map(field => (
          <div className={classes.formGroup} key={field.name}>
            <Field
              name={field.name}
              component={field.component}
              props={field.props}
              validate={field.validate}
              normalize={field.normalize}
            />
          </div>
        ))}
        <GeneralCheckbox
          id="duplicate-phone-fields"
          label="Same as Primary Contact Number"
          onChange={duplicatePhoneFields}
          value={phoneIsDuplicate}
          disabled={!primaryNumberIsMobile}
        />
        {isBuilder && (
          <div className={classes.formGroup}>
            <Field
              name="showInSearch"
              component={() => (
                <Switch
                  name="showInSearch"
                  // disabled={!isEditable}
                  checked={showInSearch}
                  onChange={e => setShowInSearch(e.target.checked)}
                />
              )}
            />
            <span className={classes.textLabel}>Show In Search</span>
          </div>
        )}

        {isBuilder && (
          <div className={classes.notificationDisclosure}>
            <div>
              <InfoIcon fontSize="small" />
            </div>
            <div>
              We will send email/SMS notifications for new job enquiries to the
              email address and the mobile number provided above. If you do not
              wish to recieve notifications you can update settings in{' '}
              <b>{`Settings > Job Notifications`}</b>
            </div>
          </div>
        )}
        <div className={classes.hidden}>
          <Field
            name="legal"
            component={GeneralCheckbox}
            id="legal-hidden-checkbox"
          />
        </div>
      </CardContent>
    </Card>
  );
};

FieldsGroupOne.propTypes = propTypes;

const mapStateToProps = state => ({
  formValues: getFormValues(FORMS.REGISTRATION_LONG)(state),
});

export default withStyles(styles)(connect(mapStateToProps)(FieldsGroupOne));
